export const spaceToDashAndLowercase = (str: string) => {
  return str.toLowerCase().replaceAll(/\s/g, '-').trim()
}
